'use strict';

/**
 * Component to truncate text on an html page. Original text will be stored in 'title' and 'tooltip' attribute.
 * @param text The text to truncate if it exceeds the passed in length.
 * @param length The desired length of the final string.  An ellipsis will be appended to string so add +3 bytes to length.
 *
 * Sample Usage:
 * <ms-truncate text="habit.name", length="51"></ms-truncate> (HTML)
 * ms-truncate(text="habit.name", length="51") (Pug)
 */
(function () {
  'use strict';

  angular.module('msCore').component('msTruncate', {
    bindings: {
      text: '<',
      length: '<'
    },
    template: '<span class="ms-truncate" title="{{$ctrl.text}}" tooltip="{{$ctrl.text}}">{{$ctrl.shortText}}</span>',
    controller: MsTruncateController
  });

  MsTruncateController.$inject = ['$filter'];

  function MsTruncateController($filter) {
    var vm = this;
    vm.$onInit = init();

    function init() {
      // Truncates up to, but not including length.
      vm.shortText = $filter('truncate')(vm.text, vm.length);
    }
  }
})();